import * as React from 'react'
import { SVGProps } from 'react'
const SvgTrophyOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M8.385 20v-1H11.5v-3.754a4.691 4.691 0 0 1-2.312-1.105 4.464 4.464 0 0 1-1.365-2.151 4.47 4.47 0 0 1-2.705-1.301C4.372 9.946 3.999 9.05 4 8V7c0-.268.1-.502.299-.701A.96.96 0 0 1 5 6h2.654V4h8.692v2H19c.268 0 .502.1.701.299.2.2.299.433.299.701v1c0 1.049-.373 1.945-1.118 2.688a4.455 4.455 0 0 1-2.705 1.3 4.451 4.451 0 0 1-1.364 2.153 4.703 4.703 0 0 1-2.313 1.105V19h3.115v1h-7.23Zm-.731-9.084V7H5v1c0 .761.254 1.416.762 1.963a2.971 2.971 0 0 0 1.892.953ZM12 14.269c.923 0 1.705-.32 2.346-.961s.962-1.424.962-2.347V5H8.692v5.962c0 .923.32 1.705.962 2.346.64.64 1.423.961 2.346.961Zm4.346-3.354a2.97 2.97 0 0 0 1.892-.952A2.79 2.79 0 0 0 19 8V7h-2.654v3.915Z'
      fill='#D64D8A'
    />
  </svg>
)
export default SvgTrophyOutline
